import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Card, CardHeader, Grid } from '@mui/material';
import { HeaderText } from '../Styled/Forms';

const StyledCard = styled(Card)`
  height: 100%;
  & a{
    text-decoration: none;    
  }
  & .MuiCardHeader-title {
    color: rgb(66, 114, 215);
    font-weight: 500;
  }
  & .MuiCardHeader-avatar {
    transition: all .5s ease-in-out;
  }
  & a:hover .MuiCardHeader-avatar {
    transform: rotateY(0deg) scale(1.5);
  }
`;

function SubPage({ pageTitle, items }) {
  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <HeaderText>{pageTitle}</HeaderText>
      </Grid>
      {items.map((item) => (
        <Grid item xl={3} lg={4} md={6} sm={12} key={item.url}>
          <StyledCard>
            <CardHeader
              component={Link}
              to={item.url}
              avatar={item.icon && <img src={item.icon} alt="" height="40px" />}
              title={item.title}
              subheader={item.desc}
            />
          </StyledCard>
        </Grid>
      ))}
    </Grid>
  );
}

SubPage.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    desc: PropTypes.string,
    icon: PropTypes.symbol,

  })).isRequired,
};

export default SubPage;
